const OPTIONS = [
  {
    value: true,
    emoji: '\uD83D\uDCCB',
    label: 'Yes, I have a specific listing',
    desc: 'I have a listing URL or photos to share',
  },
  {
    value: false,
    emoji: '\uD83D\uDD0E',
    label: 'No, general research',
    desc: 'I want to learn about this model in general',
  },
];

export default function StepSpecificity({ data, update, onNext, onBack }) {
  function select(value) {
    update({ hasSpecificListing: value });
  }

  return (
    <>
      <div className="screen-header">
        <h1 className="screen-title">Are you looking at a specific vehicle?</h1>
        <p className="screen-subtitle">
          We can analyze a specific listing or give you general model intelligence.
        </p>
      </div>

      <div style={{ flex: 1, paddingTop: 24, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {OPTIONS.map((opt) => {
          const selected = data.hasSpecificListing === opt.value;
          return (
            <button
              key={String(opt.value)}
              className="card"
              onClick={() => select(opt.value)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                textAlign: 'left',
                cursor: 'pointer',
                padding: '24px 20px',
                borderColor: selected ? 'var(--accent)' : undefined,
                background: selected ? 'var(--accent-subtle)' : undefined,
                transition: 'all 0.2s',
              }}
            >
              <span style={{ fontSize: '2rem', flexShrink: 0 }}>{opt.emoji}</span>
              <div>
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: '1rem',
                    color: selected ? 'var(--accent)' : 'var(--text-primary)',
                  }}
                >
                  {opt.label}
                </div>
                <div
                  style={{
                    fontSize: '0.875rem',
                    color: 'var(--text-secondary)',
                    marginTop: 4,
                  }}
                >
                  {opt.desc}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="nav-row">
        <button className="btn btn-secondary" onClick={onBack}>
          Back
        </button>
        <button
          className="btn btn-primary"
          disabled={data.hasSpecificListing === null}
          onClick={onNext}
        >
          Continue
        </button>
      </div>
    </>
  );
}
